import React from 'react';
import FlowStepper from '@Local/Components/FlowStepper';

/**
 * 循環訂單變更流程步驟條
 * 塞入 MainLayout 的 Header 自訂內容插槽，顯示 選品 → 確認 → 完成 三步驟進度。
 * 由各頁以 setHeaderContent(<CyclePurchaseStepper activeStep={n} onBack={fn} />) 設定；
 * 提供 onBack 時右側顯示「上一頁」返回鈕。
 */
const CYCLE_PURCHASE_STEPS = ['選擇商品', '確認變更', '完成'];

const CyclePurchaseStepper = ({ activeStep = 0, onBack }) => (
    <FlowStepper steps={CYCLE_PURCHASE_STEPS} activeStep={activeStep} onBack={onBack} />
);

export default CyclePurchaseStepper;
